var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDismiss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.76851 5.07031C6.37799 4.67979 5.74483 4.67979 5.3543 5.07031L5.07146 5.35316C4.68093 5.74368 4.68093 6.37685 5.07146 6.76737L10.3039 11.9999L5.07097 17.2328C4.68045 17.6233 4.68044 18.2565 5.07097 18.647L5.35381 18.9299C5.74434 19.3204 6.3775 19.3204 6.76803 18.9299L12.001 13.6969L17.2337 18.9296C17.6242 19.3201 18.2574 19.3201 18.6479 18.9296L18.9308 18.6468C19.3213 18.2562 19.3213 17.6231 18.9308 17.2326L13.6981 11.9999L18.9303 6.76764C19.3208 6.37712 19.3208 5.74396 18.9303 5.35343L18.6474 5.07059C18.2569 4.68006 17.6237 4.68006 17.2332 5.07059L12.001 10.3028L6.76851 5.07031Z",
    fill: "black",
    fillOpacity: 0.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDismiss);
export default __webpack_public_path__ + "static/media/dismiss.ff744002af1c9dfc52129f59c0bd0a65.svg";
export { ForwardRef as ReactComponent };